import { Injectable } from '@angular/core';
import { ActivitiesAggrigatorModel } from '@shared/model/activities-aggrigator-model';
import { ActivityVerbEnum } from '@shared/model/enum/activity-verb-enum';
import { INotifTextStrategy } from '../model/notification.model';

@Injectable({
  providedIn: 'root'
})
export class FollowNotifStrategy implements INotifTextStrategy {
  public createText(activity: ActivitiesAggrigatorModel, receiver: string, isFireBaseContext: boolean): string {
    const actorName = isFireBaseContext ? activity?.actor?.fullName ?? '' : '';

    switch (activity?.verb) {
      case ActivityVerbEnum.Followed:
        return `${actorName} شما را دنبال می‌کند.`;

      case ActivityVerbEnum.FollowRequested:
        return `${actorName} می‌خواهد شما را دنبال کند.`;

      case ActivityVerbEnum.Joined:
        return `${actorName} به بهخوان پیوست.`;

      default:
        return '';
    }
  }
}